import { graphql } from 'gatsby'
import { Layout } from '@ui/layouts/Layout'
import Seo from '@ui/layouts/seo'
import { IndexPage } from '@ui/pages'

export const query = graphql`
  query TopContents {
    allMicrocmsNews(limit: 3, sort: { modifiedPublishedAt: DESC }) {
      edges {
        node {
          ...NewsSummary
        }
      }
    }
  }
`

type DataType = {
  data: Queries.TopContentsQuery
}

const Index = ({ data }: DataType) => {
  return (
    <Layout>
      <Seo path="/" />
      <IndexPage data={data} lang="ja" />
    </Layout>
  )
}

export default Index
